import { createApi } from '@/api/modules/utils'

const baseUrl = '/media_platform/detail'
const api = createApi(baseUrl)

// 媒体详情
export const mediaPlatformDetailApi = {
    list: api('list', 'get'),
    search: api('search', 'get'),
    delete: api('delete', 'get'),
    config: api('config', 'get'),
    insert: api('insert', 'post'),
    getToken: api('get_token', 'post'),
}